<template>
    <Modal title="编辑订单信息" class="modal" v-model="editModal" width="1200">
      <Form ref="form" class="form" :label-width="80" :model="formData">
        <Row v-if="isEditisReceive">
          <i-col :span="4">
            <Form-item label="到帐方式：" prop="receiveType">
              <Select v-model.number="formData.receiveType" transfer clearable>
                <Option v-for="item in $constant.receiveType" :value="item.code" :key="item.code" :label="item.text"></Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="4">
            <Form-item label="到帐金额：" prop="money">
              <Input v-model.number="formData.money"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="到账时间：" prop="time">
              <el-date-picker
                v-model.number="pData.time"
                @change="changeTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="timestamp"
                style="width: 200px"
              >
              </el-date-picker>
            </Form-item>
          </i-col>
          <i-col :span="4">
            <Form-item label="备注：" prop="remark">
              <Input v-model="formData.remark"></Input>
            </Form-item>
          </i-col>
        </Row>
        <Row v-if="!isEditisReceive">
          <i-col :span="6">
            <Form-item label="开票时间：" prop="invoiceTime">
              <el-date-picker
                v-model.number="pData.invoiceTime"
                type="datetime"
                @change="changeInvoiceTime"
                placeholder="选择日期时间"
                value-format="timestamp"
                style="width: 200px"
              >
              </el-date-picker>
            </Form-item>
          </i-col>
          <i-col :span="4">
            <Form-item label="开票金额：" prop="invoiceMoney">
              <Input v-model.number="formData.invoiceMoney"></Input>
            </Form-item>
          </i-col>
          <i-col :span="4">
            <Form-item label="退票冲红：" prop="isRushRed">
              <Select v-model.number="formData.isRushRed" transfer clearable>
                <Option v-for="item in $constant.yesNoNum" :value="item.code" :key="item.code" :label="item.text"></Option>
              </Select>
            </Form-item>
          </i-col>
          <i-col :span="4">
            <Form-item label="退款金额：" prop="refundMoney">
              <Input v-model.number="formData.refundMoney"></Input>
            </Form-item>
          </i-col>
          <i-col :span="6">
            <Form-item label="退款时间：" prop="refundTime">
              <el-date-picker
                v-model.number="pData.refundTime"
                type="datetime"
                @change="changeRefundTime"
                placeholder="选择日期时间"
                value-format="timestamp"
                style="width: 200px"
              >
              </el-date-picker>
            </Form-item>
          </i-col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="onClose">取消</Button>
        <Button type="primary" size="large" :loading="loading" @click="onSubmit">保存</Button>
      </div>
    </Modal>
</template>
<script>
    export default {
      name: 'PerformanceModel',
      props: {
        value: {
          type: Boolean,
          default: false
        },
        formData: {
          default: {
            id: null,
            receiveType: null,
            money: null,
            time: null,
            remark: '',
            invoiceTime: null,
            invoiceMoney: null,
            isRushRed: null,
            refundMoney: null,
            refundTime: null,
            isReceive: null
          }
        },
        isEditisReceive: {
          type: Boolean,
          default: false
        },
        pData: {
          time: null,
          invoiceTime: null,
          refundTime: null
        },
        successCallback: {
          type: Function
        }
      },
      data () {
        return {
          loading: false,
        }
      },
      computed: {
        editModal: {
          get: function () {
            return this.value
          },
          set: function (newValue) {
            this.onClose()
          }
        },
      },
      methods: {
        onClose () {
          this.pData.time = null
          this.pData.invoiceTime = null
          this.pData.refundTime = null
          this.$emit('on-close')
          this.successCallback()
        },
        onSubmit () {
          let self = this
          this.$refs.form.validate((valid) => {
            if (!valid) {
              self.$Message.warning('信息输入错误!')
              return
            }
            self.$http.post('/performance/update', self.formData).then(function (res) {
              if (res && res.data > 0) {
                self.$Message.success('保存成功!')
                self.successCallback()
                self.onClose()
              }
            })
          })
        },
        changeTime () {
          this.formData.time = this.pData.time / 1000
        },
        changeInvoiceTime () {
          this.formData.invoiceTime = this.pData.invoiceTime / 1000
        },
        changeRefundTime () {
          this.formData.refundTime = this.pData.refundTime / 1000
        },
      }
    }
</script>



// WEBPACK FOOTER //
// PerformanceModel.vue?067c39d3